module.exports = __webpack_public_path__ + "static/media/31PerformancePhotos.d0261664.jpeg";